import DashboardPage from "./DashBoardPage";

export default DashboardPage